// src/redux/slices/userSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { safeParse } from "../../helper/helper";

const storedUser = JSON.parse(sessionStorage.getItem("user"));
const storedLoggedIn = JSON.parse(sessionStorage.getItem("loggedIn"));

const initialState = {
  user: storedUser || null,
  loggedIn: storedLoggedIn || null,
  loading: false,
  isSFTicketHolded: false,
  openCreateTicketBox: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user;
      safeParse(
        sessionStorage.setItem(
          "user",
          JSON.stringify(action?.payload?.user || {}),
        ),
      );
    },
    setSFTicketHold: (state, action) => {
      state.isSFTicketHolded = action.payload;
      if (action.payload) {
        safeParse(
          sessionStorage.setItem(
            "holdSFTicket",
            JSON.stringify(action.payload),
          ),
        );
      } else {
        safeParse(sessionStorage.removeItem("holdSFTicket"));
      }
    },
    setCreateTicketBox: (state, action) => {
      state.openCreateTicketBox = action.payload;
    },
    setLoggedIn: (state, action) => {
      state.loggedIn = action.payload;
      safeParse(
        sessionStorage.setItem(
          "loggedIn",
          JSON.stringify(action?.payload || {}),
        ),
      );
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.loggedIn = false;
      state.loading = false;
      state.isSFTicketHolded = false;
      state.openCreateTicketBox = false;
      safeParse(sessionStorage.removeItem("user"));
      safeParse(sessionStorage.removeItem("loggedIn"));
    },
  },
});

export const {
  setUser,
  clearUser,
  setLoggedIn,
  setSFTicketHold,
  setCreateTicketBox,
  setLoading,
} = userSlice.actions;
export default userSlice.reducer;
